<template>
  <section
    class="modal-section"
    v-show="modalSuggestIdeaGetter"
    v-modal-accessibility="{ isOpen: modalSuggestIdeaGetter, onClose: closeModal }"
  >
    <div class="disp-modal dq-modal cross-absolute" id="del-q-modal">
      <div class="container">
        <div class="answers-quizes-modal">
          <div class="modal-overlay black" @click="closeModal"></div>
          <div class="modal-content-wrap delete-quiz-modal_wrap del-q-m" style="height: 100%; max-width: 600px; width: 100%;">
            <div class="a-q-m_close" @click="closeModal"></div>
            <div class="del-q-m_body" style="padding: 24px; gap: 20px;">
              <div class="header-title">
                <p class="text-title"><b>{{ $t('poperIdea')}}</b></p>
              </div>
              <div class="body-text">
                <p style="font-weight: 600; font-size: 18px; line-height: 24px;">{{ $t('poperIdeaTitle') }}</p>
                <p>{{ $t('poperIdeaText') }}</p>
                <textarea v-model="ideaText" :placeholder="$t('poperIdeaTextPlaceholder')" class="custom-textarea"></textarea>
              </div>
              <div class="del-q-m_inputs" style="justify-content: end;">
                <input type="button"
                       style="max-width: 128px;"
                       class="btn-default-white" :value="$t('cancelAllAction')"
                       @click="closeModal()">
                <input type="button"
                       style="max-width: 200px;"
                       class="btn-default-blue" :value="$t('poperIdeaSendButton')"
                       @click="confirmModal()"
                       id="confirmation_delete_quiz"
                       @keyup.enter="confirmModal()"
                       @keyup.esc="closeModal()"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { useModalsStore } from '@/store/modalsStore'
import {useUserStore} from "@/store/userStore";
import axios from "axios";

export default {
  name: 'ModalSuggestIdea',

  data() {
    return {
      baseBackendUrl: process.env.VUE_APP_BASE_URL,
      modalsStore: useModalsStore(),
      ideaText: ''
    }
  },

  computed: {
    modalSuggestIdeaGetter() {
      return this.modalsStore.isSuggestIdeaOpen;
    },
    user() {
      const userStore = useUserStore();
      return userStore.userData || {};
    },
  },

  methods: {
    closeModal() {
      this.modalsStore.closeSuggestIdea();
      this.ideaText = '';
    },
    async confirmModal() {
      if (!this.ideaText?.trim()) return;

      const query = `
        mutation RegisterFeedback($email: String!, $idea: String!) {
          registerFeedback(email: $email, idea: $idea)
        }
      `;

      const variables = {
        email: this.user.email,
        idea: this.ideaText
      };

      const data = JSON.stringify({
        query,
        variables
      });

      const config = {
        method: 'post',
        url: this.baseBackendUrl + '/graphql/',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      };

      try {
        const response = await axios(config);
        const success = response.data?.data?.registerFeedback;

        if (success) {
          this.$notify({
            title: this.$t('modalSuggestIdeaNotificationSuccess'),
            type: "success"
          });
        } else {
          this.$notify({
            title: this.$t('modalSuggestIdeaNotificationUnsuccess'),
            type: "warn"
          });
        }
        this.closeModal();
      } catch (error) {
        console.error( error);
        this.closeModal();
      }
    },

  }
}
</script>
<style scoped>
.header-title {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}
.text-title {
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
}
.body-text {
  display:flex;
  flex-direction: column;
  justify-content: start;
  gap: 20px
}
.custom-textarea {
  padding: 16px;
  border-radius: 8px;
  border-color: #E6E8F1;
  max-width: 550px;
  width: 100%;
  height: 150px;
  resize: none;
}
.custom-textarea::placeholder {
  color: #808080;
}
</style>
